import React, { useState, useRef } from "react";
import ProjectCard from "./ProjectCard";
import ProjectTag from "./ProjectTag";
import { motion, useInView } from "framer-motion";
import "./project.css";



const projectsData = [
  {
    id: 1,
    title: "Video Streamer",
    description: "An application that allows you to stream videos",
    image: "/images/video.jpg",
    tag: ["All", "React", "Node.JS"],
    gitUrl: "https://github.com/coderQoce/video-streaming2.git ",
    previewUrl: "//",
  },
  {
    id: 2,
    title: "ChatBox",
    description: "A application that allows you to chat with other users online ",
    image: "/images/chatbox.jpg",
    tag: ["All", "React", "Node.JS"],
    gitUrl: "https://github.com/coderQoce/chat-box.git",
    previewUrl: "/",
  },
  {
    id: 3,
    title: "Yoruba Homonym System",
    description: "A system that allows you to search for Yoruba Homonyms",
    image: "/images/homonyms.jpg",
    tag: ["All", "React", "Node.JS"],
    gitUrl: "https://github.com/coderQoce/yoruba-homonyms.git",
    previewUrl: "https://yoruba-orthography.vercel.app/",
  },
  {
    id: 4,
    title: "Blog-Site",
    description: "A Blog application",
    image: "/images/blog.jpg",
    tag: ["All", "React", "Node.JS"],
    gitUrl: "https://github.com/coderQoce/Onyx-Blog.git ",
    previewUrl: "https://onyxblog.netlify.app/",
  },
  {
    id: 5,
    title: "Crop Analysis System",
    description: "An application that allows farmer to check crop disease",
    image: "/images/crop.jpg",
    tag: ["All", "React", "Node.JS"],
    gitUrl: "https://github.com/coderQoce/cropanalysis.git",
    previewUrl: "https://crop-analysis.vercel.app",
  },
  {
    id: 6,
    title: "Rock Paper Scissors Game",
    description: "A game that allows two users to compete",
    image: "/images/rps.jpg",
    tag: ["All", "Python"],
    gitUrl: "https://github.com/coderQoce/Python_projects-Games- ",
    previewUrl: "/",
  },
  {
    id: 7,
    title: "Ping Pong Game",
    description: "This is a game where paddle bounces ball between two users",
    image: "/images/pong.jpg",
    tag: ["All", "Python"],
    gitUrl: "https://github.com/coderQoce/Python_projects-Games- ",
    previewUrl: "/",
  },
  {
    id: 8,
    title: "School MS",
    description: "An Online School Management System",
    image: "/images/4.png",
    tag: ["All", "React"],
    gitUrl: "https://github.com/KSwitch1303/school-MS-frontend",
    previewUrl: "https://school-ms-frontend.vercel.app/",
  },
  {
    id: 9,
    title: "School MS - Backend",
    description: "An Online School Management System",
    image: "/images/4.png",
    tag: ["All", "NodeJS"],
    gitUrl: "https://github.com/KSwitch1303/School-Management-System",
    previewUrl: "https://school-ms-frontend.vercel.app/",
  },
  {
    id: 10,
    title: "Bank Loan Page",
    description: "A site to help banks make loan application easier",
    image: "/images/5.png",
    tag: ["All", "React", "NodeJS"],
    gitUrl: "https://github.com/KSwitch1303/FAMFB_LOAN_SITE",
    previewUrl: "https://famfb-loan.vercel.app/",
  },
  
];

const ProjectsSection = () => {
  const [tag, setTag] = useState("All");
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const handleTagChange = (newTag) => setTag(newTag);

  const filteredProjects = projectsData.filter((project) =>
    project.tag.includes(tag)
  );

  return (
    <section id="projects" className="projects-section">
      <h2 className="section-title" id="portfolio">My Projects</h2>
      <div className="tags-container">
        <ProjectTag
          onClick={() => handleTagChange("All")}
          name="All"
          isSelected={tag === "All"}
        />
        <ProjectTag
          onClick={() => handleTagChange("React")}
          name="React"
          isSelected={tag === "React"}
        />
         <ProjectTag
          onClick={() => handleTagChange("Node.JS")}
          name="Node.JS"
          isSelected={tag === "Node.JS"}
        />
        <ProjectTag
          onClick={() => handleTagChange("Python")}
          name="Python"
          isSelected={tag === "Python"}
        />

      </div>
      <ul ref={ref} className="projects-list">
        {filteredProjects.map((project) => (
          <motion.li
            key={project.id}
            initial={{ y: 50, opacity: 0 }}
            animate={isInView ? { y: 0, opacity: 1 } : {}}
            transition={{ duration: 0.3 }}
          >
            <ProjectCard
              title={project.title}
              description={project.description}
              imgUrl={project.image}
              gitUrl={project.gitUrl}
              previewUrl={project.previewUrl}
            />
          </motion.li>
        ))}
      </ul>
    </section>
  );
};

export default ProjectsSection;
